import { ContractOP } from '@cemex-core/cmx-api';
import * as moment from 'moment';

/**
 * Compares two ContractOP objects by their document creation date and contract code.
 *
 * @param a - The first ContractOP object to compare.
 * @param b - The second ContractOP object to compare.
 * @returns A negative number if `a` should come before `b`, a positive number if `a` should come after `b`, or 0 if they are equal.
 *
 * The comparison is performed first by the `documentCreationDate` property in descending order.
 * If the dates are equal, it then compares the `contractCode` property in ascending order.
 */
function orderByDateAndcontractCode(a: ContractOP, b: ContractOP): number {
  const aDate = moment(a.documentCreationDate);
  const bDate = moment(b.documentCreationDate);
  if (aDate.isBefore(bDate)) {
    return 1;
  }
  if (aDate.isAfter(bDate)) {
    return -1;
  }

  return b.contractCode.localeCompare(a.contractCode);
}

export function getMostRecentContract(contracts: ContractOP[]): any[] {
  if (contracts.length === 0) {
    return [];
  }
  return contracts.sort(orderByDateAndcontractCode);
}
